import React, { useState, useContext, useCallback, useEffect } from "react"
import styled from "styled-components"
import Loader1 from "../../interceptors/loader-interceptor"
import { JourneyContext } from "../context/journeyContext"
import { findCurrentJourneyCode, getDateInFormat } from "../services/helperFunctions"
import {checkPaymentStatusEnquiry, getCamsPayManadateStatus, paymentText, saveApplication, saveBasbaTransactionLogs, saveTransactionDetails } from "../../services/apiservice"
import { ErrorContext } from "../context/errorContext";
import { errorToastr } from "../../services/error-handler"
const status={
  pending:"pending",
  success:"success",
  failed:"failed"
}
const ApprovedIc=<svg xmlns="http://www.w3.org/2000/svg"  height="150px" width="150px" version="1.1" id="Capa_1" viewBox="0 0 344.963 344.963">
<g>
	<path  fill='#ffffff'  d="M321.847,86.242l-40.026-23.11l-23.104-40.02h-46.213l-40.026-23.11l-40.026,23.11H86.239   l-23.11,40.026L23.11,86.242v46.213L0,172.481l23.11,40.026v46.213l40.026,23.11l23.11,40.026h46.213l40.02,23.104l40.026-23.11   h46.213l23.11-40.026l40.026-23.11v-46.213l23.11-40.026l-23.11-40.026V86.242H321.847z M156.911,243.075   c-3.216,3.216-7.453,4.779-11.671,4.72c-4.219,0.06-8.455-1.504-11.671-4.72l-50.444-50.444c-6.319-6.319-6.319-16.57,0-22.889   l13.354-13.354c6.319-6.319,16.57-6.319,22.889,0l25.872,25.872l80.344-80.35c6.319-6.319,16.57-6.319,22.889,0l13.354,13.354   c6.319,6.319,6.319,16.57,0,22.889L156.911,243.075z"/>
</g>
</svg>

const DeniedIc=<svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" width="150px" height="150px" viewBox="0 0 200 200" data-name="Layer 1" id="Layer_1"><title/><path d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165Z"/><path d="M128.5,74a9.67,9.67,0,0,0-14,0L100,88.5l-14-14a9.9,9.9,0,0,0-14,14l14,14-14,14a9.9,9.9,0,0,0,14,14l14-14,14,14a9.9,9.9,0,0,0,14-14l-14-14,14-14A10.77,10.77,0,0,0,128.5,74Z"/></svg>

export default function PendingTransactionBasba(props) {
  const [timeLeft, setTimeLeft] = useState(300); // 5:00 in seconds (5*60)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [apiStatus, setApiStatus] = useState(status.pending);
  const [showBasbaFailedPage,setShowBasbaFailedPage] = useState(false);
  const[checkstatus,setCheckstatus] =useState(false)
  const [allJourneyData, setAllJourneyData] = useState()
  
  

 const callApi = useCallback(async (currentTime) => {
  try {
    const res = await getCamsPayManadateStatus({ journeyId: journeyState.journeyId });
    console.info(currentTime)
    if(currentTime<=0){
      setApiStatus(status.failed);
    }
    else{
      setApiStatus(res?.data?.status?.toLowerCase());
    }
    // setApiStatus(status.success)
  } catch (error) {
     if(currentTime<=0){
      setApiStatus(status.failed);
    }
    console.error('API call failed:', error?.response?.data?.data?.message || error.message);
    // errorToastr("Something went wrong while fetching status");
  }
}, [journeyState.journeyId]);


useEffect(() => {
  handleResumePendingScreenState()
}, [])


  useEffect(() => {
    // Call API immediately when component mounts (at 5:00)
    callApi(300)
  }, [callApi]);

  useEffect(() => {
    if (timeLeft < 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        const newTime = prevTime - 1;
        // Call API at 00:00 (when timer reaches 0)
        if (newTime === 0) {
          callApi(0);
        }
        // Call API every 30 seconds (at 270, 240, 210, 180, 150, 120, 90, 60, 30)
        if (newTime > 0 && newTime % 30 === 0) {
          callApi(newTime);
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, callApi]);

  useEffect(() => {
    if (apiStatus === status.success || apiStatus === status.failed) {
      setTimeLeft(-1); // This will stop the timer and hide the clock
    }
  }, [apiStatus]);

  const resetTimer = () => {
    setTimeLeft(300)
    // Call API when timer is reset to 5:00
    callApi(300);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const getTimerColor = () => {
    if (timeLeft <= 60) return 'bg-danger'; // Red when less than 1 minute
    if (timeLeft <= 120) return 'bg-warning'; // Yellow when less than 2 minutes
    return 'bg-info'; // Blue for normal time
  };

  const handleProceed = () => {
    if(apiStatus===status.failed){
      setShowBasbaFailedPage(true);
      return;
    }
    //if success
    let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: journeyState.premium ,
        lastPageCode: props.pageId,
        paymentStep:  'L',
        isBasbaAttempted:'Y',//will be used later in resume journey to filter basba specific sections
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
      },
    }
    saveApplication(sendPayload).then(res => {
    const enachPageIndex=journeyState.journeySteps.pages[props.currentPageIndex].sections.findIndex(section=>section.sectionId==="eNach-physicalMandate")
    setErrorState({})
    if(enachPageIndex && enachPageIndex!=-1) props.setCurrentSectionIndex(enachPageIndex) // this moves to enach page
    setErrorState({})
    setErrorState({})
    })

  }

  const handleResumePendingScreenState=()=>{
    let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: journeyState.premium ,
        lastPageCode: props.pageId,
        paymentStep:  'L',
        isBasbaAttempted:'Y',//will be used later in resume journey to filter basba specific sections
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
      },
    }
    saveApplication(sendPayload)
  }

  const handleCheckStatus = () => {
    let temp = journeyState.journeySteps
    let lastTransaction = allJourneyData?.transactionDetails?.transactions?.[allJourneyData?.transactionDetails?.transactions?.length - 1] || []
    if (!checkstatus) {
      let payload = {
        applicationNumber : journeyState?.applicationNo
      }
      checkPaymentStatusEnquiry(payload).then((data) => {
        // console.log(res_str);
        const receipts = data?.data?.response || [];
        if (receipts.length > 0){
          if (receipts[receipts.length - 1].receiptStatus !== "Cancelled"){
            // success case
            const paymentStatus = "Success"
            lastTransaction.status = paymentStatus;
            let payloadForSaveTransaction = {
              journeyId: journeyState.journeyId,
              ...lastTransaction
            }

            saveBasbaTransactionLogs(payloadForSaveTransaction)
              .then(res => {
                let tempPageIndexToChange = temp.pages.findIndex(
                  element => element.pageId === "makePayment"
                )
                let pageShowWithTransactionStatus = temp.pages[
                  tempPageIndexToChange
                ].sections.map(element => {
                  if (element.sectionId === "pending-transaction-basba") {
                    element.sectionId = "eNach-physicalMandate"
                    element.name = "eNach/Physical Mandate"
                  }
                  return element
                })
                temp.pages[
                  tempPageIndexToChange
                ].sections = pageShowWithTransactionStatus
                setJourneyState(prev => {
                  return {
                    ...prev,
                    journeySteps: temp,
                    paymentDecryptData: lastTransaction,
                  }
                })
              })
              .catch(err => {
                console.log("checkPaymentStatusFailed")
              })

          }else{
            // failure case
            errorToastr("The SI mandate creation failed from your bank account. Please click on Proceed to retry the payment.")
          }
        }
      }).catch(() => {})
    } else {
      errorToastr("Please close session and re-try")
    }
    setCheckstatus(true)
  }


  if (showBasbaFailedPage) {
  props?.setCurrentSectionIndex(0) // this moves to first section of next page
  }

  return (
    <>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
              `}
      </style>
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                    <h1 className="iselect-heading">
                      {status[apiStatus]?.charAt(0)?.toUpperCase() + status[apiStatus]?.slice(1)+`${apiStatus===status.success?"ful":""}`} Transaction
                    </h1>
                  </div>
                  <div className="app-quatation nri-mt-space hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>

                <div className="iselect-padding payment-design successful-page">
                  <div className="success-content">
                    <div className="card-body text-center p-4 p-md-5">
                      <div className="d-flex justify-content-center mb-4">
                      {
                        apiStatus === status.success ? (
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center bg-success"
                            style={{
                              width: 'clamp(200px, 15vw, 150px)',
                              height: 'clamp(200px, 15vw, 150px)',
                              fontSize: 'clamp(2rem, 4vw, 2rem)',
                              fontWeight: 'bold',
                              color: 'white',
                              transition: 'background-color 0.3s ease'
                            }}
                          >
                         {ApprovedIc}
                            </div>
                          ) : apiStatus === status.failed ?
                            (
                              <div
                                className={`rounded-circle d-flex align-items-center justify-content-center bg-danger`}
                                style={{
                                  width: 'clamp(200px, 15vw, 150px)',
                                  height: 'clamp(200px, 15vw, 150px)',
                                  fontSize: 'clamp(2rem, 4vw, 2rem)',
                                  fontWeight: 'bold',
                                  color: 'white',
                                  transition: 'background-color 0.3s ease'
                                }}
                              >
                                {DeniedIc}
                              </div>
                            ) : (
                              <div
                                className={`rounded-circle d-flex align-items-center justify-content-center ${getTimerColor()}`}
                                style={{
                                  width: 'clamp(200px, 15vw, 150px)',
                                  height: 'clamp(200px, 15vw, 150px)',
                                  fontSize: 'clamp(2rem, 4vw, 2rem)',
                                  fontWeight: 'bold',
                                  color: 'white',
                                  transition: 'background-color 0.3s ease'
                                }}
                              >
                                {timeLeft > 0 ? formatTime(timeLeft) : '00:00'}
                              </div>
                            )}
                      </div>
                      {/* Message */}
                      <div className="text-center">
                        <p className="text-muted mb-0 lh-base px-2 fs-3 fs-md-1 fw-semibold">
                          {apiStatus === status.success
                            ? "Lien approved, please proceed"
                            : timeLeft > 0 && apiStatus!==status.failed
                              ? "Please wait, payment method registration is in process"
                              : "Oops! Seems like your LIEN creation failed from your bank account. Please click on check status button to confirm transaction status."
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  {(apiStatus === status.success || apiStatus === status.failed ) && 
                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-right">
                        <a
                          style={{
                            marginRight: "5px",
                          }}
                        >
                          {" "}
                          <input
                            className="previous-btn cen text-uppercase"
                            style={{
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                            }}
                            type="submit"
                            value="Check Status"
                            onClick={handleCheckStatus}
                          />
                          <input
                            className="previous-btn cen text-uppercase"
                            style={checkstatus ? {
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                            } : 
                              {
                                pointerEvents: "none",
                                background : "gray",
                                color : "white",
                                border: "none",
                                 padding: "14px 40px",
                                cursor : "not-allowed"
                              }}
                            type="submit"
                            value="PROCEED"
                            onClick={handleProceed}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  }
                  {apiStatus === status.failed && (
                    <p className="text-muted mb-0 lh-base px-2 fs-3 fs-md-1 fw-semibold" style={{
                      marginTop : "100px",
                      textAlign : "center"
                    }}>In case the lien was not created on your account, you can re-try by clicking on Proceed Button.</p>
                  )}
                </div>

                <div className="clearfix"></div>
                {/* <!--mobile view button--> */}
                {(apiStatus === status.success || apiStatus === status.failed) &&
                <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                  <div className="iselect-mg-bottom">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                        <div className="previous-btn cen" style={{
                          marginRight : "5px"
                        }}>
                          <a>
                            {" "}
                            <button
                              type="submit"
                              value="button1"
                              style={{
                                backgroundColor: "transparent",
                                padding: "0px 10px",
                                border: "none",
                                color: "#fff",
                              }}
                              onClick={handleCheckStatus}
                            >
                              Check Status
                            </button>
                          </a>
                        </div>
                        <div className="previous-btn cen" style={!checkstatus ? {
                            pointerEvents: "none",
                                background : "gray",
                                color : "white",
                                border: "none",
                                cursor : "not-allowed"
                        } : {}}>
                         
                          <a>
                            {" "}
                            <button
                              type="submit"
                              value="button1"
                              style={checkstatus ? {
                                backgroundColor: "transparent",
                                padding: "0px 10px",
                                border: "none",
                                color: "#fff",
                              } : {
                                pointerEvents: "none",
                                background : "gray",
                                color : "white",
                                border: "none",
                                cursor : "not-allowed"
                              }}
                              onClick={handleProceed}
                            >
                              PROCEED
                            </button>{" "}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                {/* <!--mobile view button-->  */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}